// import { cn } from "@/lib/utils"
import { urlForImage } from '@/sanity/lib/image'
import Image from 'next/image'
import Link from 'next/link'

interface ArticleCardProps {
	article: any
	size?: 'sm' | 'default'
}

export default function ArticleCard({ article, size = 'default' }: ArticleCardProps) {
	// const tagClass = cn("absolute top-4 left-4 inline-flex style-caption bg-white rounded-[2px] before:content-['#'] text-black", {
	// 	"style-caption px-[12px] py-[5px]": size === "default",
	// 	"font-new-sans text-[14px] leading-[1.166666666666667] px-[8px] py-[3px]" : size === "sm"
	// })

	// const textClass = size === "default" ? "style-body--lg" : "style-body"

	return (
		<Link href={`/journal/${article?.slug?.current}`} className="journal-item text-black group  transition">
			<div className="image relative">
				{article?.image && (
					<Image
						className={`w-full h-auto aspect-[3/2] object-cover rounded-weak overflow-hidden animate-fade-in`}
						src={urlForImage(article?.image).width(1080).url()}
						sizes="(min-width: 1112px) 33vw, (min-width: 712px) 50vw, 100vw"
						width={article?.image?.asset?.metadata?.dimensions?.width}
						height={article?.image?.asset?.metadata?.dimensions?.height}
						placeholder="blur"
						blurDataURL={article?.image?.asset?.metadata?.lqip}
						alt={article?.image?.alt || ''}
						unoptimized={article?.image?.asset?.url?.includes(".gif") ? true : false} // mark Gif images as unoptimized (Next.js does not support Gif optimisation yet)
					/>
				)}
				<div
					className={`absolute top-4 left-4 inline-flex px-[12px] pt-[4px] pb-[4px] font-new-sans text-[14px] leading-[1.166666666666667] bg-white rounded-full before:content-['#'] text-black`}>
					<span className="pb-[2px]">{article?.tag?.title?.toLowerCase()}</span>
				</div>
			</div>
			<div className="excerpt mt-4 relative">
				<p className={`style-body md:style-body--lg mb-1 group-hover:text-blue`}>{article?.title}</p>
				<p className={`style-body md:style-body--lg italic `}>{article?.excerpt}</p>
			</div>
		</Link>
	)
}
